import Vue from 'vue';
import Router from 'vue-router';
import MenuPrincipal from '@/components/MenuPrincipal';
import Registro from '@/components/Registro';

import Reimprimir_Registro from '@/components/Reimprimir_Registro';
import Presentar from '@/components/Presentar';
import Login from '@/components/Login';
import Imprimir_Registro from '@/components/Imprimir_Registro';
import Imprimir_Boleta_Examen from '@/components/Imprimir_Boleta_Examen';
import Datos_Alumno from '@/components/Datos_Alumno';
import Examenes from '@/components/Examenes/Examenes';
import Instrucciones_Kuder from '@/components/Examenes/Kuder/Instrucciones';
import Preguntas_Kuder from '@/components/Examenes/Kuder/Preguntas';
import Instrucciones_Mmpi2 from '@/components/Examenes/Mmpi2/Instrucciones';
import Preguntas_Mmpi2 from '@/components/Examenes/Mmpi2/Preguntas';
import Instrucciones_Catell from '@/components/Examenes/Catell/Instrucciones';
import Preguntas_Catell from '@/components/Examenes/Catell/Preguntas';
import Instrucciones_CAQ from '@/components/Examenes/CAQ/Instrucciones';
import Preguntas_CAQ from '@/components/Examenes/CAQ/Preguntas';
import Instrucciones_Terman from '@/components/Examenes/Terman/Instrucciones';
import Preguntas_Terman from '@/components/Examenes/Terman/Preguntas';
import Instrucciones_MmpiA from '@/components/Examenes/MmpiA/Instrucciones';
import Preguntas_MmpiA from '@/components/Examenes/MmpiA/Preguntas';
import Instrucciones_Edwards from '@/components/Examenes/Edwards/Instrucciones';
import Preguntas_Edwards from '@/components/Examenes/Edwards/Preguntas';
import Entrevista from '@/components/Examenes/Entrevista/Entrevista';
import Dibujos from '@/components/Examenes/Dibujos/Dibujos';
import Instrucciones_depBeck from '@/components/Examenes/DepresionBeck/Instrucciones';
import Preguntas_depBeck from '@/components/Examenes/DepresionBeck/Preguntas';
const Instrucciones_16PF = () => import('@/components/Examenes/16PF/Instrucciones');
const Preguntas_16PF = () => import('@/components/Examenes/16PF/Preguntas');
const Instrucciones_RYFF = () => import('@/components/Examenes/RYFF/Instrucciones');
const Preguntas_RYFF = () => import('@/components/Examenes/RYFF/Preguntas');

Vue.use(Router)

export default new Router({
  routes: [
    {path: '/',name: 'MenuPrincipal',component: MenuPrincipal, children:[
    	{path: 'registro',name: 'Registro',component: Registro},
        {path: 'reimprimir_registro',name: 'Reimprimir_Registro',component: Reimprimir_Registro},
    	{path: 'presentar',name: 'Presentar',component: Presentar},
        {path: 'login',name: 'Login',component: Login},
    	{path: 'datos_alumno',name: 'Datos_Alumno',component: Datos_Alumno},
        {path: 'examenes',name: 'Examenes',component: Examenes},
	]},
	{path: '/imprimir_registro/:folio',name: 'Imprimir_Registro',component: Imprimir_Registro},
    {path: '/imprimir_boleta_examen',name: 'Imprimir_Boleta_Examen',component: Imprimir_Boleta_Examen},
    {path: '/examenes/kuder_v/instrucciones',name: 'kuder_v_instrucciones',component: Instrucciones_Kuder},
    {path: '/examenes/kuder_v/preguntas',name: 'kuder_v_preguntas',component: Preguntas_Kuder},
    {path: '/examenes/mmpi2/instrucciones',name: 'mmpi2_instrucciones',component: Instrucciones_Mmpi2},
    {path: '/examenes/mmpi2/preguntas',name: 'mmpi2_preguntas',component: Preguntas_Mmpi2},
    {path: '/examenes/catell/instrucciones',name: 'catell_instrucciones',component: Instrucciones_Catell},
    {path: '/examenes/catell/preguntas',name: 'catell_preguntas',component: Preguntas_Catell},
    {path: '/examenes/caq/instrucciones',name: 'caq_instrucciones',component: Instrucciones_CAQ},
    {path: '/examenes/caq/preguntas',name: 'caq_preguntas',component: Preguntas_CAQ},
    {path: '/examenes/terman/instrucciones/:serie',name: 'terman_instrucciones',component: Instrucciones_Terman},
    {path: '/examenes/terman/preguntas/:serie',name: 'terman_preguntas',component: Preguntas_Terman},
    {path: '/examenes/mmpia/instrucciones',name: 'mmpia_instrucciones',component: Instrucciones_MmpiA},
    {path: '/examenes/mmpia/preguntas',name: 'mmpia_preguntas',component: Preguntas_MmpiA},
    {path: '/examenes/edwards/instrucciones',name: 'edwards_instrucciones',component: Instrucciones_Edwards},
    {path: '/examenes/edwards/preguntas',name: 'edwards_preguntas',component: Preguntas_Edwards},
    {path: '/examenes/entrevista',name: 'entrevista',component: Entrevista},
    {path: '/examenes/dibujos',name: 'dibujos',component: Dibujos},
    {path: '/examenes/depBeck/instrucciones',name: 'depBeck_instrucciones',component: Instrucciones_depBeck},
    {path: '/examenes/depBeck/preguntas',name: 'depBeck_preguntas',component: Preguntas_depBeck},
    {path: '/examenes/16pf/instrucciones',name: '16pf_instrucciones',component: Instrucciones_16PF},
    {path: '/examenes/16pf/preguntas',name: '16pf_preguntas',component: Preguntas_16PF},
    {path: '/examenes/RYFF/instrucciones',name: 'RYFF_instrucciones',component: Instrucciones_RYFF},
    {path: '/examenes/RYFF/preguntas',name: 'RYFF_preguntas',component: Preguntas_RYFF},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js